export function analyzeGraphData(data) {
    const stats = {
        etfConnections: {}, // Number of stocks directly connected to each ETF
        etfOverlaps: {} // Overlapping connections between ETFs
    };

    // Create node lookup to avoid repeated finds
    const nodeLookup = data.nodes.reduce((acc, node) => {
        acc[node.id] = node;
        return acc;
    }, {});

    // Initialize the statistics objects for each ETF
    data.nodes.forEach(node => {
        if (node.group > 0) { // Assume group > 0 indicates an ETF
            stats.etfConnections[node.id] = {
                count: 0,
                stocks: new Set() // Use a Set to store unique stock ids
            };
            stats.etfOverlaps[node.id] = {};
            data.nodes.forEach(otherNode => {
                if (otherNode.group > 0 && otherNode.id !== node.id) {
                    stats.etfOverlaps[node.id][otherNode.id] = 0; // Initialize overlap count
                }
            });
        }
    });

    // Populate the statistics based on the links
    data.links.forEach(link => {
        const sourceNode = nodeLookup[link.source.id || link.source];
        const targetNode = nodeLookup[link.target.id || link.target];

        if (sourceNode.group > 0 && targetNode.group === 0) {
            stats.etfConnections[sourceNode.id].stocks.add(targetNode.id);
        } else if (targetNode.group > 0 && sourceNode.group === 0) {
            stats.etfConnections[targetNode.id].stocks.add(sourceNode.id);
        }
    });

    // Convert Sets to counts for ETF connections
    Object.keys(stats.etfConnections).forEach(etfId => {
        stats.etfConnections[etfId].count = stats.etfConnections[etfId].stocks.size;
    });

    // Calculate overlaps based on shared stocks
    Object.keys(stats.etfOverlaps).forEach(etfId => {
        Object.keys(stats.etfOverlaps[etfId]).forEach(otherEtfId => {
            const intersection = new Set([...stats.etfConnections[etfId].stocks].filter(x => stats.etfConnections[otherEtfId].stocks.has(x)));
            stats.etfOverlaps[etfId][otherEtfId] = intersection.size;
        });
    });

    // Make stocks array for easier display
    Object.keys(stats.etfConnections).forEach(etfId => {
        stats.etfConnections[etfId].stocks = Array.from(stats.etfConnections[etfId].stocks);
    });

    return stats;
}
